export default "__VITE_ASSET__c05a11c3__"